import {SubscriptionMap} from '../farmApi';

export default (map: SubscriptionMap) => {
  return [...map.values()].some((sub) => sub.slots === 0 && sub.maxSlots === 0);
};
